<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NMPqsx/tc-custom/9780715335376.jpg?1705003722683" alt="This image is the cover for the book Sew Many Bags, Sew Little Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sew Many Bags, Sew Little Time
      </h1>
      <p class="bookDescription body article font2">
        <p>Sew yourself a sassy collection of bags and accessories to carry you from day to night, and work to play</p><p><b>Sew stylish . . .</b><br/>Create fashion with function; pretty shoppers, smart satchels, cute cosmetics purses and more, plus must-have coordinating accessories</p><p><b>Sew special . . .</b><br/>Felt, denim, cotton, and even waterproof; fabrics new and old are mixed and embellished for one-of-a-kind creations</p><p><b>Sew simple . . .</b><br/>No-fuss sewing techniques, from easy appliquT to simple seams, ensure the bags are quick and easy, leaving you with more time to enjoy them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sally Southern
      </h2>
      
      <p class="authorDescription body article"><P><B>&ldquo;The perfect beginner&rsquo;s guide, it illustrates</B><B></B><B>all the basic techniques,</B><B></B><B>including appliqu&eacute;, quilting, patchwork and cross stitch . . . a must have</B><B></B><B>title!&rdquo; &mdash;<I>Crafts Beautiful</I></B></P><P> Sew yourself a sassy collection of bags and accessories to carry you from day to night, and work to play </P><P><B>Sew stylish . . .</B></P><P> Create fashion with function; pretty shoppers, smart satchels, cute cosmetics purses and more, plus must-have coordinating accessories. </P><P><B>Sew special . . .</B></P><P> Felt, denim, cotton, and even waterproof; fabrics new and old are mixed and embellished for one-of-a-kind creations. </P><P><B>Sew simple . . .</B></P><P> No-fuss sewing techniques, from easy appliqu&eacute; to simple seams, ensure the bags are quick and easy, leaving you with more time to enjoy them. </P><P><B>&ldquo;This is</B><B>&#160; </B><B>fab treat of a book. It&rsquo;s sure to make bag ladies of us all!&rdquo; &mdash;<I>Quick &amp;&#160;</I></B><B><I>Crafty</I></B></P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David and Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ec46712